import { Grid, MenuItem, Select } from '@mui/material';
import React, { useState } from 'react';
import { client } from 'shared';
import { PointDetailResponse, PointValue, PointValueToAdd } from '../types';
import { PrimaryButton, TextButton, Text } from 'library';
import { AddPointValue } from './AddPointValue';

export function EditPointsContent({
    pointDetails,
    onClose,
    userId,
}: {
    pointDetails: PointDetailResponse;
    onClose: () => void;
    userId: number;
}) {
    const [selectedPointValue, setSelectedPointValue] = useState<number>();
    const [pointValueToAdd, setPointValueToAdd] = useState<PointValueToAdd>({
        name: '',
        value: 0,
        description: '',
    });

    const valueOptions: { id: number; name: string; value?: number }[] = [
        ...pointDetails.point_values.map((value: PointValue) => {
            return { id: value.id, name: value.name, value: value.value };
        }),
        {
            id: -1,
            name: 'Add',
        },
    ];

    const addingPoint = selectedPointValue === -1;

    function updateUserPoints() {
        const postBody = addingPoint ? pointValueToAdd : { id: selectedPointValue };
        client(`api/point/update-user-point/`, {
            method: 'POST',
            body: { worker_user_id: userId, point_value: postBody },
        }).then(() => {
            setSelectedPointValue(undefined);
            onClose();
        });
    }
    return (
        <Grid item container style={{ gap: 20, marginTop: 20 }}>
            <Text bold>Current Points: {pointDetails.point.total}</Text>
            <Select
                value={selectedPointValue}
                onChange={(e) => setSelectedPointValue(e.target.value as number)}
                style={{ width: '100%' }}
            >
                {valueOptions.map((value) => {
                    return (
                        <MenuItem key={value.id} value={value.id}>
                            {value.name} {value.value}
                        </MenuItem>
                    );
                })}
            </Select>
            {addingPoint && <AddPointValue pointValueToAdd={pointValueToAdd} setPointValueToAdd={setPointValueToAdd} />}
            <Grid item container style={{ marginTop: 20, gap: 10 }}>
                <PrimaryButton onClick={updateUserPoints}>
                    {addingPoint ? 'Add and Update' : 'Update'} Points
                </PrimaryButton>
                <TextButton onClick={() => setSelectedPointValue(undefined)}>Clear Selection</TextButton>
            </Grid>
        </Grid>
    );
}
